import { Link } from 'react-router-dom';
import { articlesData } from '@/mocks/articles';

export default function LatestArticles() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-400 mb-4">
              Learn More
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-tight">
              Latest Articles
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            In-depth guides and tips to get the most from your <strong className="font-semibold text-foreground-700">vigorbuy spreadsheet</strong>.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articlesData.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-background-300/80 transition-all duration-300 hover:scale-[1.01] cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {/* Category Badge */}
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-[10px] font-semibold bg-white/90 text-foreground-800 backdrop-blur-sm">
                  {article.category}
                </span>
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm font-medium text-primary-500">
                  Read Article
                  <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-200">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All link */}
        <div className="mt-10 text-center">
          <Link
            to="/articles/vigorbuy-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 text-foreground-500 hover:text-foreground-900 text-sm font-medium transition-colors duration-200 cursor-pointer"
          >
            Browse All Shopping Guides
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}